
export const VeckoFields = {
  DATE: 'date',
  VERBATIMS: 'verbatims',
  GLOBAL_SATISFACTION: 'enhancement.satisfaction',
};
